import 'react-app-polyfill/stable';
import {loadRuntimeConfig} from './config/runtimeConfig';

const showStartupError = (error) => {
    const root = document.getElementById('root');
    const title = document.createElement('h1');
    const message = document.createElement('p');

    title.textContent = 'Не удалось запустить приложение';
    message.textContent = error.message;
    root.appendChild(title);
    root.appendChild(message);
};

loadRuntimeConfig()
    .then(() => require('./bootstrap'))
    .catch(showStartupError);
